// --------------------------------------------------------------
// Created On: 2025-11-06
// Author: Zachary Thomas
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

let initialState: CurrentUser = {
  userId: 0,
  userName: "",
  emailAddress: "",
  originalCompanyId: 0,
  companyId: 0,
  companyName: "",
  isCompanyHidden: true,
  permissions: [],
  isPackager: false,
  mfaEnabled: false,
};
const localStorageUser = localStorage.getItem("reduxCurrentUser");
if (localStorageUser !== null) {
  try {
    initialState = JSON.parse(localStorageUser) as CurrentUser;
  } catch {
    console.error("Failed to restore current user information on application load.");
  }
}

// A Redux slice for information about the current logged in user.
const currentUserSlice = createSlice({
  name: "currentUser",
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<CurrentUser>) => {
      const currentUser = {
        userId: action.payload.userId,
        userName: action.payload.userName,
        emailAddress: action.payload.emailAddress,
        originalCompanyId: action.payload.originalCompanyId,
        companyId: action.payload.companyId,
        companyName: action.payload.companyName,
        isCompanyHidden: action.payload.isCompanyHidden,
        permissions: action.payload.permissions,
        isPackager: action.payload.isPackager,
        mfaEnabled: action.payload.mfaEnabled,
      };
      localStorage.setItem("reduxCurrentUser", JSON.stringify(currentUser));
      return currentUser;
    },
  },
});

export const { setCurrentUser } = currentUserSlice.actions;
export default currentUserSlice.reducer;
